import { removeElement } from "../../utils/array";
export class InteractorManager {
    get enabled() {
        return (this.mEnabled);
    }
    set enabled(pValue) {
        this.setEnabled(pValue);
    }
    get interactors() {
        return (this.mInteractors);
    }
    get viewer() {
        return (this.mViewer);
    }
    get view() {
        return (this.mView);
    }
    constructor(pViewer) {
        this.onCameraChanged = () => {
            if (!this.mEnabled)
                return;
            //ignore updates during screenshot generation
            if (this.mViewer.isCreatingScreenshot)
                return;
            for (const tInteractor of this.mInteractors)
                tInteractor.updateViewPosition();
        };
        this.mInteractors = [];
        this.mViewer = pViewer;
        this.mView = null;
        this.setEnabled(true);
    }
    addInteractor(pInteractor) {
        if (pInteractor == null)
            return;
        this.mInteractors.push(pInteractor);
        pInteractor._setManager(this);
        pInteractor._setView(this.mView);
        if (this.mEnabled)
            pInteractor.updateViewPosition();
        else
            pInteractor.element.style.display = "none";
    }
    removeInteractor(pInteractor) {
        if (pInteractor == null)
            return;
        removeElement(this.mInteractors, pInteractor);
        pInteractor._setManager(null);
        pInteractor._setView(null);
    }
    clear() {
        this.removeInteractorsFromView();
        this.mInteractors = [];
    }
    dispose() {
        this.removeInteractorsFromView();
        this.enabled = false;
        this.mInteractors = undefined;
    }
    setEnabled(pEnabled) {
        if (this.mEnabled === pEnabled)
            return;
        this.mEnabled = pEnabled;
        if (this.mEnabled) {
            for (const tInteractor of this.mInteractors) {
                if (tInteractor.visible)
                    tInteractor.element.style.display = "block";
            }
            if (!this.setView(this.mViewer.view)) {
                this.onCameraChanged(); //update interactors
            }
        }
        else {
            for (const tInteractor of this.mInteractors) {
                if (tInteractor === this.mViewer.app.tools._activeDraggerInteractor) {
                    //delay the style change, this is necessary for firefox (tested with version 97.0.1)
                    //otherwise firefox would not send any further pointer events
                    setTimeout(() => tInteractor.element.style.display = "none");
                }
                else {
                    tInteractor.element.style.display = "none";
                }
            }
            this.setView(null);
        }
    }
    setView(pView) {
        if (pView === this.mView)
            return (false);
        if (this.mView != null) {
            this.mView.cameraControl.eventCameraChanged.removeListener(this.onCameraChanged);
            this.removeInteractorsFromView();
        }
        this.mView = pView;
        if (this.mView != null) {
            this.mView.cameraControl.eventCameraChanged.addListener(this.onCameraChanged);
            this.addInteractorsToView();
        }
        return (true);
    }
    addInteractorsToView() {
        for (const tInteractor of this.mInteractors) {
            tInteractor._setView(this.mView);
            tInteractor.updateViewPosition();
        }
    }
    removeInteractorsFromView() {
        if (this.mInteractors == null)
            return;
        for (const tInteractor of this.mInteractors)
            tInteractor._setView(null);
    }
}
